import { DataType } from '@doss/prisma/types'

export const DUPLICATE_FILTER_ALLOWED_COLUMN_TYPES = [
  DataType.STRING,
  DataType.ENUM,
  DataType.NUMBER,
  DataType.DATE,
  DataType.DATE_TIME,
  DataType.ID,
  DataType.LOOKUP,
] as const

export type DuplicateFilterAllowedColumnType =
  (typeof DUPLICATE_FILTER_ALLOWED_COLUMN_TYPES)[number]

export const DUPLICATE_FILTER_ERROR_CODES = {
  TOO_MANY_VALUES: 'duplicate_filter_too_many_values',
  UNINDEXED_VALUE: 'duplicate_filter_unindexed_value',
  LIMIT_EXCEEDED: 'duplicate_filter_limit_exceeded',
  NOT_PERMITTED: 'duplicate_filter_not_permitted',
} as const

export const MAX_DUPLICATE_FILTERS_PER_TAB = 3

export const isDuplicateFilterAllowedColumnType = (
  type: DataType,
): type is DuplicateFilterAllowedColumnType => {
  return DUPLICATE_FILTER_ALLOWED_COLUMN_TYPES.includes(type as DuplicateFilterAllowedColumnType)
}
